module.exports = __webpack_public_path__ + "img/download.2b2f39fd.png";